import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { CherryDevWordmark, MEDIA_LAB_TAGLINES } from 'components/TnoMediaLabLogo';
import { NASIOL, WEB_HERO_IMAGE, webHero } from '../nasiolContent';

const WebHero = () => (
  <Box
    component="section"
    position="relative"
    overflow="hidden"
    minHeight={{ xs: 'auto', md: 'auto' }}
    display="flex"
    alignItems="flex-start"
    sx={{
      backgroundColor: NASIOL.oceanDeep,
      backgroundImage: `
        linear-gradient(115deg, rgba(8,11,15,0.94) 0%, rgba(28,42,56,0.78) 48%, rgba(15,20,25,0.5) 100%),
        url(${WEB_HERO_IMAGE})
      `,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      color: NASIOL.white,
    }}
  >
    <Box
      position="absolute"
      inset={0}
      sx={{
        background:
          'radial-gradient(ellipse 65% 45% at 85% 15%, rgba(31,168,184,0.32) 0%, transparent 55%)',
        pointerEvents: 'none',
      }}
    />

    <Box
      position="relative"
      zIndex={1}
      width="100%"
      px={{ xs: 2.5, sm: 4, md: 7 }}
      pt={{ xs: 3.5, md: 4.5 }}
      pb={{ xs: 4, md: 5.5 }}
      maxWidth={920}
    >
      <Box mb={{ xs: 2, md: 2.5 }}>
        <Typography
          component="div"
          sx={{
            fontFamily: '"Outfit", sans-serif',
            fontSize: { xs: '1.35rem', md: '1.55rem' },
            lineHeight: 1,
            color: NASIOL.white,
          }}
        >
          <CherryDevWordmark color="inherit" fontSize="inherit" />
        </Typography>
        <Typography
          sx={{
            mt: 0.5,
            fontFamily: '"Outfit", sans-serif',
            fontWeight: 700,
            fontSize: '0.68rem',
            letterSpacing: '0.12em',
            color: 'rgba(255,255,255,0.72)',
          }}
        >
          {MEDIA_LAB_TAGLINES.web}
        </Typography>
      </Box>

      <Typography
        component="p"
        sx={{
          fontFamily: '"Outfit", "Source Sans 3", sans-serif',
          fontWeight: 700,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          fontSize: { xs: '0.7rem', md: '0.78rem' },
          color: 'rgba(255,255,255,0.78)',
          mb: 1.5,
        }}
      >
        {webHero.overline}
      </Typography>

      <Typography
        component="h1"
        sx={{
          fontFamily: '"Space Grotesk", "Outfit", sans-serif',
          fontWeight: 700,
          letterSpacing: { xs: '-0.02em', md: '-0.03em' },
          lineHeight: 0.98,
          fontSize: 'clamp(2rem, 8vw, 4rem)',
          maxWidth: '100%',
          mb: 0.75,
          textShadow: '0 12px 40px rgba(0,0,0,0.28)',
        }}
      >
        {webHero.clientName}
      </Typography>

      <Typography
        component="p"
        sx={{
          fontFamily: '"Space Grotesk", "Outfit", sans-serif',
          fontWeight: 600,
          fontSize: { xs: '1.15rem', md: '1.4rem' },
          letterSpacing: '-0.02em',
          lineHeight: 1.25,
          maxWidth: 560,
          mb: 1.5,
        }}
      >
        {webHero.title}
      </Typography>

      <Typography
        component="p"
        sx={{
          fontFamily: '"Source Sans 3", "Outfit", sans-serif',
          fontWeight: 400,
          fontSize: { xs: '0.98rem', md: '1.08rem' },
          lineHeight: 1.55,
          color: 'rgba(255,255,255,0.88)',
          maxWidth: 520,
          mb: 2.75,
        }}
      >
        <Box component="span" sx={{ fontWeight: 700, color: NASIOL.white }}>
          {webHero.congrats}{' '}
        </Box>
        {webHero.subtitle}
      </Typography>

      <Button
        href="#inversion"
        variant="contained"
        endIcon={<ArrowDownwardIcon />}
        sx={{
          px: 3.25,
          py: 1.4,
          borderRadius: 1.5,
          fontWeight: 800,
          fontFamily: '"Outfit", "Source Sans 3", sans-serif',
          bgcolor: NASIOL.sunset,
          color: NASIOL.white,
          boxShadow: '0 16px 36px rgba(0,0,0,0.22)',
          '&:hover': { bgcolor: NASIOL.sunsetSoft, color: NASIOL.oceanDeep },
        }}
      >
        {webHero.cta}
      </Button>
    </Box>
  </Box>
);

export default WebHero;
